import { ApiError } from "./api/client";

function searchErrorCode(error: ApiError): unknown {
  return error.data && typeof error.data === "object" && "code" in error.data
    ? error.data.code : undefined;
}

/** A changed term/store can recover a rejected request; repeating it cannot. */
export function retryKrogerSearch(failureCount: number, error: Error): boolean {
  if (error instanceof ApiError) {
    if (error.status >= 400 && error.status < 500) return false;
    const code = searchErrorCode(error);
    if (code === "KROGER_SEARCH_ACCESS_DENIED" || code === "KROGER_SEARCH_CONNECTION_FAILED" || code === "KROGER_SEARCH_COOLDOWN") return false;
  }
  return failureCount < 1;
}

/** Use bounded copy instead of rendering a provider's arbitrary message. */
export function krogerSearchRecovery(error: unknown): string {
  if (error instanceof ApiError) {
    switch (searchErrorCode(error)) {
      case "KROGER_SEARCH_TERM_TOO_SHORT": return "Use at least 3 characters for this search.";
      case "KROGER_SEARCH_INVALID_REQUEST": return "Change your search or check your selected store.";
      case "KROGER_SEARCH_INVALID_QUERY": return "Enter between 2 and 100 characters to search.";
      case "KROGER_SEARCH_ACCESS_DENIED":
      case "KROGER_SEARCH_CONNECTION_FAILED": return "Store search cannot connect to Kroger right now. Try again later.";
      case "KROGER_SEARCH_TIMEOUT": return "Store search timed out. Please try again.";
      case "KROGER_SEARCH_COOLDOWN": return "This search recently failed. Change your search or wait before trying again.";
    }
    if (error.status === 429) return "Kroger is limiting searches. Wait and try again later.";
    if (error.status === 401) return "Sign in again to search your store.";
    if (error.status === 400) return "Check your search and selected store.";
  }
  return "Store search is unavailable. Try again later.";
}
